import { Database, Radio } from "lucide-react";
import type { DataMode } from "../types/job";

interface HeaderProps {
  visibleCount: number;
  totalCount: number;
  mode: DataMode;
  loading: boolean;
}
export function Header({ visibleCount, totalCount, mode, loading }: HeaderProps) {
  return (
    <header className="app-header">
      <div className="wordmark" aria-label="Job Lobster">
        <span className="wordmark-symbol"><i /><i /><i /></span>
        <span>Job</span> Lobster
      </div>
      <div className="header-readout">
        <span className={`mode-readout ${loading ? "is-loading" : ""}`}>
          {mode === "live" ? <Radio size={13} /> : <Database size={13} />}
          {loading ? "scanning" : mode === "live" ? "lobster live" : "simulation"}
        </span>
        <span className="signal-count">
          <strong>{visibleCount.toString().padStart(2, "0")}</strong>
          <span>/ {totalCount.toString().padStart(2, "0")} signals</span>
        </span>
      </div>
    </header>
  );
}
